import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {summarysessionsColumns} from './columns/_columns'
import {Summarysession} from '../core/_models'
import {SummarysessionsListLoading} from '../components/loading/SummarysessionsListLoading'
import {SummarysessionsListPagination} from '../components/pagination/SummarysessionsListPagination'
import { KTCardBody, defaultSummarysessions } from '../../../../../_metronic/helpers'
import { CopySummarysessionsTable } from './CopySummarysessionsTable'
import { useQueryRequest } from '../core/QueryRequestProvider'
// import {KTCardBody} from '../../../../../../_metronic/helpers'

const SummarysessionsTable = () => {
  const summarysessions = useQueryResponseData()  
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => summarysessions, [summarysessions])
  
  const columns = useMemo(() => summarysessionsColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='p-0'>
      <CopySummarysessionsTable />
      <div className='table-responsive mb-8 data-table-report '>
        <table
          id='kt_table_summarysessions'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable table-striped  no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0 border-bottom border-gray-100'>
              {headers.map((column: ColumnInstance<Summarysession>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
  
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Summarysession>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={13}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <SummarysessionsListPagination />
      {isLoading && <SummarysessionsListLoading />}
    </KTCardBody>
  )
}

export {SummarysessionsTable}
